import styled from "styled-components";

const handleColorType = (color) => {
	switch (color) {
		case "green":
			return "var(--chart-success-color);";
		case "red":
			return "var(--chart-danger-color);";
		case "blue":
			return "var(--chart-primary-color);";
		case "white":
			return "#fff;";
		default:
			return "color: #000; background: #eee;";
	}
};

const handleWidth = (percents, width) => {
	let perc = percents + (percents * (width - 100)) / 100;
	return perc + "px";
};

export const Progress = styled.div`
	width: 150px;
	height: 20px;
	font-size: 14px;
	font-weight: 400;

	.progressListBackground {
		box-shadow: 0 4px 14px rgba(45, 45, 45, 0.4);
		background: #fff;
		width: 150px;
		height: 8px;
		border-radius: 10px;
	}

	.progressList {
		box-shadow: 0 4px 14px rgba(45, 45, 45, 0.4);
		background: ${(props) => handleColorType(props.color)};
		height: 8px;
		width: ${(props) => props.width + "px"};
		border-radius: 10px 0 0 10px;
	}

	small {
		display: flex;
		justify-content: end;
		color: gray;
	}
`;

export const ProgresNBack = styled.div`
	display: flex;
	width: 150px;
	height: 20px;
	font-size: 14px;
	font-weight: 400;

	.progressListBackground {
		box-shadow: 0 4px 14px rgba(45, 45, 45, 0.4);
		width: ${(props) => props.width + "px"};
		height: 8px;
		border-radius: 10px;
	}

	.progressList {
		box-shadow: 0 4px 14px rgba(45, 45, 45, 0.4);
		background: ${(props) => handleColorType(props.color)};
		height: 8px;
		width: ${(props) => handleWidth(props.percents, props.width)};
		border-radius: 10px 0 0 10px;
	}

	.perc {
		width: 50px;
		display: flex;
		align-items: center;
		height: 8px;
		margin-left: 10px;
	}
`;
